export default __webpack_public_path__ + "static/media/pvilla6-2.ff7873fe.jpg";